<template>
  <div class="riseupGoal container-padding">
    <div class="container-padding">
      <div class="goal">יעד riseup</div>
      <div class="title">
        <div>כמה כסף ישאר בסוף {{this.monthName}}?</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'RiseupGoal',
  computed: {
    ...mapGetters('cashflowView', ['monthName']),
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  .riseupGoal {
    height: 160px;
    margin-bottom: 16px;
    color: $riseup_gray_1;
    border-radius: 3px;
    border: dashed 1px $riseup_gray_1;

    .container-padding {
      padding: 18px;
    }

    .goal {
      color: $riseup_gray_1;
      font-size: 10px;
      font-weight: bold;
    }

    .title {
      color: $riseup_gray_1;
      font-family: GretaSans;
      font-size: 24px;
      font-weight: bold;
      margin: 4px 0 22px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/pending-month/components/RiseupGoal.vue